export const theme = {
  /* background: '#f5f8fb', */
  fontFamily: 'Roboto, Arial, Helvetica, sans-serif',
  headerBgColor: '#F27405',
  headerFontColor: '#fff',
  headerFontSize: '21px',
  botBubbleColor: '#F27405',
  botFontColor: '#fff',
  userBubbleColor: '#fff',
  userFontColor: '#8f8e91',
};
